import { DateRangeSelector } from "@/components/stats/DateRangeSelector";
import { OverviewCards } from "@/components/stats/OverviewCards";
import { VolumeTrend } from "@/components/stats/VolumeTrend";
import { ExerciseBreakdown } from "@/components/stats/ExerciseBreakdown";
import PageTitleScript from "@/components/MetaScript";
export function StatsOverviewPage() {
  return (
    <div className="flex flex-col">
      <PageTitleScript title="Stats Overview" />

      {/* Date Range Selector */}
      <DateRangeSelector />

      {/* Overview Statistics */}
      <div className="px-6 mb-12">
        <OverviewCards />
      </div>

      <div className="px-6 mb-6">
        <VolumeTrend />
      </div>

      {/* Exercise Breakdown */}
      <div className="px-6 mb-4">
        <ExerciseBreakdown />
      </div>
    </div>
  );
}
